import jQuery from 'jquery/dist/jquery.js'; globalThis.$ = globalThis.jQuery = jQuery;
import 'popper.js';
// import "bootstrap/js/dist/tooltip.js";
// import "bootstrap/js/dist/dropdown.js";
import "bootstrap";
import IMask from "imask";

/** Some global behaviors which I think will be useful. */

/* An approximation of the old bootstrap 3 .button('loading') behavior.
*
* Usage:
*   $(selector).loading();          // disables button & shows a spinner, with text from data-loading-html attribute if present on element.
*   $(selector).loading('foo');     // disables button & shows a spinner followed by the string 'foo'
*   $(selector).loading(false);     // restores original button content and re-enables button.
* */
(function($){
    $.fn.loading = function (html = '') {
        const spinnerHtml = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>';
        const loadingHtml = html || this.data('loading-html') || '';
        const isLoading = html !== false;

        if (isLoading) {
            this.data('original-html', this.html());
            this.html( spinnerHtml + ' ' + loadingHtml);
            this.attr("disabled", true);
        }

        if (!isLoading || html === false) {
            this.html(this.data('original-html'));
            this.attr('disabled', false);
        }

        return this;
    }
})(jQuery);

/* Bootstrap-style data-attribute api for Imask. add 'data-imask="<pattern>"' */
(function($){
    $.fn.inputMask = function(){
        const pattern = this.data('imask') || this.attr('pattern');
        if (pattern){
            var opts = {
                mask: pattern,
                placeholderChar: '_'
            }
            IMask(this[0], opts);
        }
        return this;
    }
})(jQuery);

/*
 * Enable some behaviors on dom-ready.
 */
jQuery(function($) {
    // Anything with a tooltip attribute should be a tooltip.
    $('[data-toggle="tooltip"]').tooltip();

    // Enable input mask data-attribute api.
    $('input[data-imask]').inputMask();

    // If you add data-loading-text to your form, the submit button will animate on submit.
    $('form[data-loading-text]').on('submit', function(e){
        var form = $(e.target);
        var btn = form.find('button[type=submit]');
        btn.loading(form.data('loading-text'))
    });

});

